module.exports = __webpack_public_path__ + "static/media/email.86da9b62.svg";